import PhantomButton from "../../../../Atoms/PhantomButton";
import Rating from "../../../../Atoms/Rating";

interface Props {
  average: number | null;
  totalRecords: number;
  onOpenReviews: (e: any) => void;
}

export default function Stats({ average, totalRecords, onOpenReviews }: Props) {
  return totalRecords > 0 && average ? (
    <span style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginLeft: -4 }}>
        <Rating value={Math.round(average)} />
      </span>
      <span style={{ marginLeft: 18 }}>
        <PhantomButton onClick={onOpenReviews}>
          See all {totalRecords} reviews
        </PhantomButton>
      </span>
    </span>
  ) : null;
}
